import { text, integer, index, uniqueIndex } from 'drizzle-orm/sqlite-core'
import { defineTable } from '@kubdee/sdk/schema'
import { connectorInstances } from './connectors-instances'

// ============================================================================
// connectors_rate_limits — Per-instance rate limit counters
//
// Hot-path table: upserted on every outbound API call. Unique key on
// (instance_id, endpoint, window_start) so a sliding-window writer collapses
// into O(1). Rows expire via background cleanup keyed on updated_at.
// ============================================================================
export const connectorRateLimits = defineTable(
  'connectors',
  'rate_limits',
  {
    id: text('id').primaryKey(),
    instanceId: text('instance_id')
      .notNull()
      .references(() => connectorInstances.id, { onDelete: 'cascade' }),
    endpoint: text('endpoint').notNull(),
    windowStart: text('window_start').notNull(),
    windowMs: integer('window_ms').notNull(),
    requestCount: integer('request_count').notNull().default(0),
    maxPerWindow: integer('max_per_window').notNull(),
    updatedAt: text('updated_at').notNull(),
  },
  (table) => [
    uniqueIndex('connectors_rate_limits_key_unique').on(
      table.instanceId,
      table.endpoint,
      table.windowStart,
    ),
    index('connectors_rate_limits_updated_at_idx').on(table.updatedAt),
  ],
)

export type ConnectorRateLimit = typeof connectorRateLimits.$inferSelect
export type NewConnectorRateLimit = typeof connectorRateLimits.$inferInsert
